import { useState } from 'react';
import { Plus, Minus } from '@phosphor-icons/react';

const faqs = [
  {
    id: 1,
    question: 'How does the QR code attendance system work?',
    answer:
      'Members open the Inked app, show their personal QR code, and a leader scans it to mark attendance instantly. Members can also scan event QR codes themselves. No typing, no roll calls, no paperwork.',
  },
  {
    id: 2,
    question: 'What happens if there is no internet connection?',
    answer:
      'No problem. The system tracks attendance offline and automatically syncs everything when you reconnect. Nothing gets lost — all records are saved and updated as soon as you are back online.',
  },
  {
    id: 3,
    question: 'Do members need to download an app?',
    answer:
      'Yes — members download the Inked app from the App Store (iOS) or Google Play (Android). The app gives each member a personal QR code for check-in and lets them view their own attendance history.',
  },
  {
    id: 4,
    question: 'Can I track attendance for both small and large organisations?',
    answer:
      'Absolutely. The system scales from 50 people to 50,000+ members. Whether you are managing a small group or a large multi-department organisation, everything runs smoothly in one place.',
  },
  {
    id: 5,
    question: 'How do I add new members?',
    answer:
      'As an admin you send an invite link to new members via email or text. The link includes their pre-selected group assignment, so they just complete a quick registration and are ready to check in.',
  },
  {
    id: 6,
    question: 'Can I export attendance reports?',
    answer:
      'Yes. Export attendance data to CSV any time. View real-time reports, track trends, and download records for your own analysis or record-keeping.',
  },
  {
    id: 7,
    question: 'Why use this instead of spreadsheets or roll calls?',
    answer:
      'Save 10+ hours every week. No more calling names, manual data entry, or chasing people for attendance. Get instant reports, eliminate human errors, and spend your time on what matters.',
  },
  {
    id: 8,
    question: 'How quickly can I get started?',
    answer:
      'Setup takes minutes. Create your account, add your team structure, invite members, and start tracking. No complicated training — you can be up and running the same day.',
  },
];

export default function FAQ() {
  const [openId, setOpenId] = useState(null);

  return (
    <section id="faq" className="bg-gray-50 py-24 px-6 lg:px-8 border-t border-gray-100">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <p
            className="text-xs font-semibold text-[#2228B6] uppercase tracking-widest mb-4"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            FAQ
          </p>
          <h2
            className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-4"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Frequently asked questions
          </h2>
          <p className="text-lg text-gray-500" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Everything you need to know about Inked.
          </p>
        </div>

        {/* Accordion */}
        <div className="divide-y divide-gray-200">
          {faqs.map((faq) => (
            <div key={faq.id}>
              <button
                onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
                className="w-full flex items-center justify-between py-5 text-left group"
              >
                <span
                  className="text-base font-semibold text-gray-700 group-hover:text-gray-900 transition-colors pr-8"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {faq.question}
                </span>
                <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full border border-gray-200 bg-white text-gray-400 group-hover:border-gray-300 transition-colors">
                  {openId === faq.id
                    ? <Minus size={14} weight="bold" />
                    : <Plus size={14} weight="bold" />
                  }
                </span>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-80 opacity-100 pb-5' : 'max-h-0 opacity-0'
                }`}
              >
                <p
                  className="text-sm text-gray-500 leading-relaxed whitespace-pre-line"
                  style={{ fontFamily: 'Manrope, sans-serif' }}
                >
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
